function setZIndexForSections() {
  const sections = document.querySelectorAll('.secvh');
  if (sections.length === 0) return;

  sections.forEach((el, index) => {
    el.style.zIndex = index + 1;
  });
}

document.addEventListener('DOMContentLoaded', setZIndexForSections);
